


































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { MessageController } from '@/services/request.service';
import { RouteRecord } from 'vue-router';
import { saveAs } from 'file-saver';
import moment from 'moment';

@Component
export default class SentMsgDetail extends Vue {
  @Prop({ default: () => {} }) public detailInfo!: any;
  public moment = moment;

  public get locale(): string {
    return this.$i18n.locale;
  }

  public openFile(resource: any): void {
    const suffixArray = ['doc', 'docx', 'xls', 'xlsx'];
    if (suffixArray.includes(resource.type)) {
      this.download(resource);
    } else {
      window.open(resource.resourceUrl);
    }
  }

  public download(info: any): void {
    saveAs(info.resourceUrl, info.name);
  }
}
